(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instafeed"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadInstaFeed();
        observer.unobserve(entry.target);
      }
    });
  });
  observer.observe(document.querySelector('#insta-feed'));

  function loadInstaFeed() {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/instafeed.js'; /* <-- Apna Instafeed JS URL yaha daalein agar custom hai */
    script.defer = true;
    document.body.appendChild(script);
  }
});

  } catch(e) { console.error(e); }
})();
})();
